// src/contexts/loading.context.tsx
import { createContext } from 'react';

export interface LoadingProps {
    show: boolean;
    content?: string;
    backgroundColor?: string;
    mask?: boolean;
}

interface LoadingContextInterface {
    loadingState: LoadingProps;
    setLoading: (props: Partial<LoadingProps>) => void;
}

const LoadingContext = createContext<LoadingContextInterface>({} as LoadingContextInterface);

export default LoadingContext;